import { CustomerModelType } from '@teinor/erp/types/company/customer'
import { BillingGroupCustomerRelModelType } from '@teinor/erp/types/company/config/billingGroup/billingGroupCustomerRel'
import React, { Fragment, useMemo } from 'react'
import { ComponentWithPermissions } from '../../../../baseComponents/CreateRoutering/types'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import BaseScreenTableInner from '../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { dictionaryFromJsonArr } from '../../../../utils/globals/dictionary'
import { ColumnTableSchema } from '../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { CustomRenderString, DeleteRow, EditRow } from '../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { BillingGroupPayload } from '../../../../utils/reducers/company/billingGroups'
import TwinTable from '../../../../baseComponents/TwinTable'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import { RowData } from '../../../../baseComponents/TwinTable/types'
import { AllReduxPayloads } from '../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../utils/hoc/withLoading'
import ModalCECustomerBillingGroupConnect from './ModalCECustomerBillingGroup'
import ModalDeleteCustomerBillingGroup from './ModalDeleteCustomerBillingGroup'

interface CustomerBillingGroupsProps extends ComponentWithPermissions {
    basicData: CustomerModelType | null
}

const CustomerBillingGroups: React.FC<CustomerBillingGroupsProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('billingGroups', 'Grupos de facturación'),
        newText: t('addBillingGroup', 'Nuevo  grupo de facturación'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableCustomerBillingGroupsConnect} DeleteModalComponent={ModalDeleteCustomerBillingGroup} CreateModalComponent={ModalCECustomerBillingGroupConnect} EditModalComponent={ModalCECustomerBillingGroupConnect} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ CustomerId: basicData?.id }} />
    )
}
type TableCustomerBillingGroupsProps = TableComponentBaseScreenInnerProps & ReduxCustomerBillingGroupsConnector & {}


const TableCustomerBillingGroups: React.FC<TableCustomerBillingGroupsProps> = ({ setTableInstance, billingGroups, extraWhereParams, setOpened, userPermissions }) => {
    const { t } = useTwinTranslation()
    const dictBillingGroups = useMemo(() => dictionaryFromJsonArr(billingGroups?.dictionaryBillingGroup || {}), [billingGroups?.dictionaryBillingGroup])
    const columns: ColumnTableSchema<BillingGroupCustomerRelModelType> = [
        {
            id: 'BillingGroupId',
            dataKey: 'BillingGroupId',
            label: t('billingGroup', 'Grupo de Facturación'),
            customRender: (parameterValue) => <CustomRenderString value={dictBillingGroups[parameterValue]} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('BillingGroup', 'Grupo de facturación') }
            },
            searchKey: 'BillingGroup.name'
        },
        {
            id: 'BillingTypeSellOptions',
            dataKey: 'BillingTypeSellOptions',
            label: t('byDefault', 'Por defecto'),
            customRender: (parameterValue, allRowData) => { return <RenderBillingTypeSellOptions allRowData={allRowData} billingGroups={billingGroups} /> },

        },
        {
            id: 'edit',
            dataKey: 'BillingGroupId',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'BillingGroupId',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='CustomerBillingGroups' getDataFrom='/api/app/customer/customerBillingGroup/getAllBillingGroupsCustomers' defaultOrder={{ defaultOrderField: 'BillingGroupId', order: 'asc' }}
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })}
            setTableInstance={setTableInstance} extraWhereParams={extraWhereParams}
        />
    )
}
interface RenderBillingTypeSellOptionsProps {
    billingGroups: BillingGroupPayload
    allRowData?: RowData
}
const RenderBillingTypeSellOptions: React.FC<RenderBillingTypeSellOptionsProps> = ({allRowData, billingGroups}) => {
    const billingTypesOptions = billingGroups?.billingTypesAllSellOptions || {}
    let result: JSX.Element[] = []
    for (const value of allRowData?.BillingTypeSellOptions) {
        const myBillingTypeOption = billingTypesOptions[value]
        if (myBillingTypeOption) {
            result.push(<span key ={value} className='mr-5'>{myBillingTypeOption.code}</span>)
        }
    }
    return (<Fragment>{result}</Fragment>)
}


const tableCustomerBillingGroupsDispatch = {
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapTableCustomerBillingGroupsConnector = (state: AllReduxPayloads) => ({ billingGroups: state.billingGroups })
const tableCustomerBillingGroupsConnector = connect(mapTableCustomerBillingGroupsConnector, tableCustomerBillingGroupsDispatch)
type ReduxCustomerBillingGroupsConnector = ConnectedProps<typeof tableCustomerBillingGroupsConnector>

const tableCustomerBillingGroupsConnectLoading = withLoading(TableCustomerBillingGroups, [{ fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups'}])

const TableCustomerBillingGroupsConnect = tableCustomerBillingGroupsConnector(tableCustomerBillingGroupsConnectLoading)

export default CustomerBillingGroups